import React, { ReactElement } from "react";
import { Error } from "../Error";
import { concatStringFromClassesArrayList } from "../../Utils";
import { ClassItem } from "../../Types/ClassItem";

export interface Props {
  id?: string;
  classes?: string;
  inline?: boolean;
  attributes?: { [key: string]: string };
  error?: React.ComponentProps<typeof Error>;
  dontWrap?: boolean;
  spellCheck?: boolean;
  dataTestId: string;
  children: ReactElement;
}

export const Field = (props: Props) => {
  const renderField = () => {
    if (props.dontWrap) {
      return props.children;
    } else {
      const fieldClassList: ClassItem = {
        defaultClass: "ons-field",
        optionalClasses: [
          props.inline ? "ons-field--inline" : null,
          props.classes ? props.classes : null,
        ],
      };
      const fieldClassName: string =
        concatStringFromClassesArrayList(fieldClassList);

      return (
        <div
          {...(props.id ? { id: props.id } : {})}
          className={
            !props.error ? fieldClassName : fieldClassList.defaultClass
          }
          spellCheck={props.spellCheck || true}
          data-testid={props.dataTestId}
          {...(props.attributes
            ? Object.entries(props.attributes)
                .map(([attribute, value]) => ({ [attribute]: value }))
                .reduce((acc, attribute) => ({ ...acc, ...attribute }), {})
            : {})}
        >
          {props.children}
        </div>
      );
    }
  };
  return props.error ? (
    <Error
      text={props.error.text}
      id={props.error.id}
      dataTestId={props.dataTestId + "-error"}
      classes={props.classes}
    >
      {renderField()}
    </Error>
  ) : (
    renderField()
  );
};
